
import TrackerCompanies from './tracker-companies.vue'
import TrackerContacts from './tracker-contacts.vue'
import TrackerTopics from './tracker-topics.vue'

export default {
  components: {TrackerCompanies, TrackerContacts, TrackerTopics},
  props: {
    widget: {type: Object, required: true}
  }
}
